<template>
    <div class="moodboard moodboard-content-template">
        <!-- Banner -->
        <div class="banner banner--theme banner--moodboard">
            <div class="banner-primary">
                <div class="container">
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="moodboard-form-wrapper">
                                <form>
                                    <div class="form-group">
                                        <label for="project">Your Moodboard</label>
                                        <div class="wrapper-project-name">
                                            <input type="text" class="form-control" id="project" name="project" :value="projectName" v-on:keyup.enter="projectNameChange" placeholder="Moodboard name">
                                            <a class="button button--solid-black save-button" aria-label="Save" title="Save" @click="projectNameChange">Save</a>
                                        </div>
                                    </div>
                                </form>

                                <div class="moodboard-cta-wrapper">
                                    <div class="moodboard-cta">
                                        <a class="button button--solid-black download-button" aria-label="Download" title="Download" @click="downloadTrigger" data-category="Moodboard" data-action="Download" data-label="Moodboard">Download</a>
                                        <a class="button button--clear-black share-button" aria-label="Share" title="Share" @click="showShare" data-category="Moodboard" data-action="Share" data-label="Moodboard">Share</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="align-center add-to-moodboard-wrapper">
                                <i
                                    class="icon icon--add"
                                    @click="showModal"
                                ></i> Add to Moodboard
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Saved Favorites -->
        <section class="moodboard--ideas padding--lg">
            <div class="container">
                <!-- <masonry
                        :cols="{default: 3, 1908: 3, 1400: 3, 1199: 2, 576: 1}"
                        :gutter="{default: '30px', 700: '30px'}"
                >
                    <div
                            v-for="(item, index) in data.mymoodboard"
                            :key="index" :id="item.id"
                    >
                        <colour-card v-if="item.type == 'Colour'" :data="item" />
                        <card v-else 
                            :data="item" 
                            theme="simple" 
                            location="moodboardIdeas"
                            :allowPin="data.allowPinItem"
                        ></card>
                    </div>
                </masonry> -->

                <masonry-wall :items="moodboardItems" :ssr-columns="2" :min-columns="2" :gap="masonryWallGap">
                    <template #default="{ item, index }">
                        <colour-card 
                            v-if="item.type == 'Colour'" 
                            :data="item" 
                        />
                        <card v-else 
                            :data="item" 
                            theme="simple" 
                            location="moodboardIdeas"
                            :allowPin="data.allowPinItem"
                            @toggleFav="toggleFav"
                        ></card>
                    </template>
                </masonry-wall>

            </div>
        </section>


        <div class="inspiration-gallery-modal">
            <modal-fullpage
                v-if="isModalVisible"
                @close="closeModal"
            >
                <template v-slot:content>
                    
                    <div class="modal-heading">
                        <h2>Inspiration Gallery</h2>
                    </div>

                    <section class="item-filter" ref="itemFilterRef" :class="{collapsed: !isFilterExpanded, sticky: isFilterSticky}">
                        <div :class="{container: isFilterSticky}">
                            <div class="row">
                                <div class="col-xs-12">
                                    <div class="filter-wrapper filter-wrapper--text-only">
                                        <div class="filter-wrapper--label">Application Filter</div>
    
                                        <div class="filter-wrapper--hide-scroll">
                                            <div class="inner" id="filter-wrapper--primary" @scroll="slideOnScroll('filter-wrapper--primary')">
                                                <div class="items">
                                                    <a href="#"
                                                        class="category"
                                                        :class="[
                                                            selectedFilter.category.length === 0 ? 'selected' : null
                                                        ]" 
                                                        @click.stop.prevent="filter('reset-this-filter', 'category', null)"
                                                    >
                                                        <span class="title">
                                                            <span class="bolder">All</span>
                                                            <span class="light">All</span>
                                                        </span>
                                                    </a>
    
                                                    <a href="#"
                                                        class="category" 
                                                        :class="[
                                                            selectedFilter.category.includes(category.urlsegment) ? 'selected' : null
                                                        ]" 
                                                        v-for="(category, index) in filterKeys.categories" 
                                                        :key="index"  
                                                        @click.stop.prevent="filter(category.filterid, 'category', category.urlsegment)" 
                                                        :data-id="category.filterid"
                                                    >
                                                        <span class="title">
                                                            <span class="bolder">{{category.title}}</span>
                                                            <span class="light">{{category.title}}</span>
                                                        </span>
                                                    </a>
                                                
                                                <div class="spacer">&nbsp;</div>
                                                </div>
                                            </div>
                                        </div>
    
                                        <button id="filter-wrapper--prev--primary" class="filter-wrapper--prev" @click="slidePrev('filter-wrapper--primary')">
                                            <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                            </svg>
                                        </button>
    
                                        <button id="filter-wrapper--next--primary" class="filter-wrapper--next" @click="slideNext('filter-wrapper--primary')">
                                            <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                            </svg>
                                        </button>
                                    </div>
                                    <div class="filter-wrapper filter-wrapper--text-icon">
                                        <div class="filter-wrapper--label">Colours and Profiles Filter</div>
    
                                        <div class="filter-wrapper--hide-scroll">
                                            <div class="inner" id="filter-wrapper--secondary" @scroll="slideOnScroll('filter-wrapper--secondary')">
                                                <div class="items">
                                                    <a href="#" @click.stop.prevent="filter('reset-this-filter', 'tag', null)"
                                                        :class="[
                                                            selectedFilter.tag.length<=0 ? 'selected' : null
                                                        ]" 
                                                    >All</a>
                                                    <a href="#"
                                                        v-for="(tag, index) in filterKeys.tags.filter(tag => !selectedFilter.tag.includes(tag.urlsegment))"
                                                        :key="index"
                                                        @click.stop.prevent="filter(tag.filterid, 'tag', tag.urlsegment)" 
                                                        :data-id="tag.filterid"
                                                    >
                                                        <span v-if="tag.type === 'PROFILE' && tag.profile" :style="`background-color: #ffffff; background-image: url(${tag.profile})`" class="colour-icon"></span>
                                                        <span v-if="tag.type !== 'PROFILE' && tag.colour" :style="`background-color: #${tag.colour}`" class="colour-icon"></span>
                                                        
                                                        <span class="title">
                                                            <span class="bolder">{{tag.title}}</span>
                                                            <span class="light">{{tag.title}}</span>
                                                        </span>
                                                    </a>
    
                                                    <div class="spacer">&nbsp;</div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <button id="filter-wrapper--prev--secondary" class="filter-wrapper--prev" @click="slidePrev('filter-wrapper--secondary')">
                                            <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                            </svg>
                                        </button>
    
                                        <button id="filter-wrapper--next--secondary" class="filter-wrapper--next" @click="slideNext('filter-wrapper--secondary')">
                                            <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                            </svg>
                                        </button>
                                    </div>
    
                                    <div v-show="selectedFilter.tag.length > 0" class="filter-wrapper filter-wrapper--text-icon filter-wrapper--text-icon-selected">
                                        <div class="separator"></div>
    
                                        <div class="filter-wrapper--hide-scroll">
                                            <div class="inner" id="filter-wrapper--secondary-selected" @scroll="slideOnScroll('filter-wrapper--secondary-selected')">
                                                <div class="items">
                                                    <a
                                                        class="selected"
                                                        v-for="(tag, index) in selectedFilter.tag.map(selectedTag => filterKeys.tags[filterKeys.tags.findIndex(tag => tag.urlsegment === selectedTag)])"
                                                        :key="index"
                                                        :data-id="tag.filterid"
                                                    >
                                                        <span v-if="tag.type === 'PROFILE' && tag.profile" :style="`background-color: #ffffff; background-image: url(${tag.profile})`" class="colour-icon"></span>
                                                        <span v-if="tag.type !== 'PROFILE' && tag.colour" :style="`background-color: #${tag.colour}`" class="colour-icon"></span>
                                                        
                                                        <span class="title">
                                                            <span class="bolder">{{tag.title}}</span>
                                                            <span class="light">{{tag.title}}</span>
                                                        </span>
    
                                                        <span
                                                            class="clear"
                                                            @click.stop.prevent="filter(tag.filterid, 'tag', tag.urlsegment)"
                                                        >
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                                <mask id="mask0_1_383" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                                                    <rect width="24" height="24" fill="#D9D9D9"/>
                                                                </mask>
                                                                <g mask="url(#mask0_1_383)">
                                                                    <path d="M8.4 17L7 15.6L10.6 12L7 8.42499L8.4 7.02499L12 10.625L15.575 7.02499L16.975 8.42499L13.375 12L16.975 15.6L15.575 17L12 13.4L8.4 17Z" fill="#1C1B1F"/>
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </a>
                                                    <div class="spacer">&nbsp;</div>
                                                </div>
                                            </div>
                                        </div>
    
                                        <button id="filter-wrapper--prev--secondary-selected" class="filter-wrapper--prev" @click="slidePrev('filter-wrapper--secondary-selected')">
                                            <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                            </svg>
                                        </button>
    
                                        <button id="filter-wrapper--next--secondary-selected" class="filter-wrapper--next" @click="slideNext('filter-wrapper--secondary-selected')">
                                            <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9883 4.05805L0.74518 7.83378L0.133789 7.29018L3.79281 4.04947L0.143476 0.817341L0.74518 0.282318L4.9883 4.05805Z" fill="black"/>
                                            </svg>
                                        </button>
                                    </div>
    
                                    <div class="filter-wrapper--separator"></div>
    
                                    <div class="filter-wrapper--toggle">
                                        <div
                                            class="toggle"
                                            @click="toggleExpandFilter"
                                        >
                                            <p>
                                                Filters
                                            </p>
                                            <span>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00024 8.99994L0.000244141 1.13342L1.00805 -6.10352e-05L7.01615 6.78355L13.0083 0.0178985L14.0002 1.13342L7.00024 8.99994Z" fill="black"/>
                                                </svg>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section v-show="isFilterSticky" class="item-filter--holder" ref="itemFilterHolderRef"></section>

                    <masonry-wall class="space--md" :items="filteredItems" :ssr-columns="2" :min-columns="2" :gap="masonryWallGap">
                        <template #default="{ item, index }">
                            <card 
                                :data="item" 
                                theme="simple" 
                                location="moodboardModal"
                                @toggleFav="toggleFavModal"
                            ></card>
                        </template>
                    </masonry-wall>
                    
                    <div class="modal-action">
                        <a @click="reloadPage" aria-label="next" title="next" class="button button--solid-black button--effect">Next</a>
                    </div>
                </template>
            </modal-fullpage>
        </div>

        <modal-info
            v-show="isMoodboardDownloadInfo"
            @close="closeModalDownloaInfo"
            ctaClass="center"
            ctaText="Continue"
        >
            <template v-slot:content>
                <div class="row moodboard-download-info">
                    <div class="col-xs-12 wysiwyg-content">
                        <p>Moodboard downloading</p>
                    </div>
                </div>
            </template>
        </modal-info>

        <modal-info
                v-show="isInfoVisible"
                @close="closeInfo"
        >
            <template v-slot:content>
                <div class="row moodboard-modal-info">
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-7 col-xl-7">
                        <h5 class="medium" v-if="data.infoModalTitle">{{data.infoModalTitle}}</h5>
                        <div v-if="data.infoModalContent" v-html="data.infoModalContent"></div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-5">
                        <img v-if="data.infoModalImage" class="image-item" :src="data.infoModalImage" :alt="data.infoModalTitle">
                    </div>
                </div>
            </template>
        </modal-info>

        <modal-share
                v-show="isShareVisible"
                @close="closeShare"
        >
            <template v-slot:content>
                <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-7 col-xl-7">
                        <h4 v-if="data.shareModalTitle">{{data.shareModalTitle}}</h4>
                        <div v-if="data.shareModalContent" v-html="data.shareModalContent"></div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-5 col-xl-5">
                        <img v-if="data.shareModalImage" class="image-item" :src="data.shareModalImage" :alt="data.shareModalTitle">
                    </div>
                    
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <form>
                            <div class="form-group">
                                <label for="shareLink">Share Link</label>
                                <input type="text" class="form-control" id="shareLink" name="shareLink" :value="data.shareLink" readonly>
                                <!-- <a class="button button--solid-black" @click="copyShare" aria-label="Copy share">Copy</a> -->
                            </div>
                        </form>
                    </div>
                    <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2">
                        <a class="button button--solid-black" @click="copyShare" aria-label="Copy share" data-category="Moodboard" data-action="Share" data-label="Moodboard Share Link">Copy Link</a>
                        <a class="button button--solid-black" target="_blank" :href="data.mailtoLink" aria-label="Copy share" data-category="Moodboard" data-action="Share" data-label="Moodboard Share Email">Email</a>
                        <!-- <a class="button button--solid-black" @click="closeShare" aria-label="Close modal">Continue</a> -->
                    </div>
                </div>
            </template>
        </modal-share>

    </div>
</template>


<script>
    import axios from 'axios';
    import { Card, ColourCard, Cta, ModalInfo, ModalShare, ModalFullpage } from "../components";
    import { notify } from "@kyvg/vue3-notification";
    import { debounce } from 'vue-debounce'

    export default {
        name: "v-moodboard",
        components: {
            ModalFullpage,
            ModalInfo,
            ModalShare,
            Card,
            ColourCard,
            Cta
        },
        props: {
            data: {
                type: Object
            }
        },
        data () {
            return {
                'projectName': this.data.projectName,
                'isInfoVisible': this.data.isInfoVisible,
                'isShareVisible': false,
                'isModalVisible': false,
                itemsToShow: 12,
                totalItems: 0,
                items: [],
                filteredItems: [],
                moodboardItems: [],
                selectedFilter: {
                    category: [],
                    tag: []
                },
                filterKeys: {
                    categories: [],
                    tags: []
                },
                isMoodboardDownloadInfo: false,
                isFilterSticky: false,
                isFilterExpanded: true,
                scrollTicking: false,
                prevWindowPosY: 0,
                masonryWallGap: 30,
            }
        },
        mounted() {
            this.items = this.convertItemsObjToArray(this.data.ideas)
            this.filteredItems = this.convertItemsObjToArray(this.data.ideas)
            this.moodboardItems = this.convertItemsObjToArray(this.data.mymoodboard)
            this.totalItems = this.items.length

            this.filterKeys = this.getFilteredCatAndTagList(this.data.ideas, this.data.categories, this.data.tags);

            const app = this;

            this.setMasonryWallGap();

            window.addEventListener('resize', () => {
                clearTimeout(this.intervalID);
                this.intervalID = setTimeout(() => {
                    app.detectButtonVisibility();
                    app.setMasonryWallGap();
                }, 250);
            });
        },
        computed: {
            filteredData: function() {
                let resultData = this.data;

                if (this.serviceType) {
                    resultData = resultData.filter(item => item.serviceTypeID === this.serviceType)
                }

                return resultData
            },

        },
        methods: {
            slidePrev(id) {
                const elem = document.getElementById(id);
                elem.scrollBy(window.innerWidth/3 * (-1), 0);
            },
            slideNext(id) {
                const elem = document.getElementById(id);
                elem.scrollBy(window.innerWidth/3, 0);
            },
            slideOnScroll(id) {
                const slideBuffer = 10;
                const elem = typeof id === 'string' ? document.getElementById(id) : id;
                const isScrolling = elem.querySelector('.items').offsetWidth > elem.offsetWidth;

                elem.parentNode.parentNode.classList.add('no-scroll');
                if(isScrolling){
                    elem.parentNode.parentNode.classList.remove('no-scroll');
                }

                if(isScrolling && elem.scrollLeft >= (elem.querySelector('.items').offsetWidth - elem.offsetWidth - slideBuffer)) {
                    elem.parentNode.parentNode.classList.add('is-max');
                    elem.parentNode.parentNode.classList.remove('is-min');
                } else if(isScrolling && elem.scrollLeft <= slideBuffer) {
                    elem.parentNode.parentNode.classList.remove('is-max');
                    elem.parentNode.parentNode.classList.add('is-min');
                } else {
                    elem.parentNode.parentNode.classList.remove('is-max');
                    elem.parentNode.parentNode.classList.remove('is-min');
                }
            },
            detectButtonVisibility() {
                let status = true;

                const slideItems = [
                    document.getElementById('filter-wrapper--primary'),
                    document.getElementById('filter-wrapper--secondary'),
                    document.getElementById('filter-wrapper--secondary-selected')
                ];
                const slideButtons = [
                    document.getElementById('filter-wrapper--next--primary'),
                    document.getElementById('filter-wrapper--next--secondary'),
                    document.getElementById('filter-wrapper--next--secondary-selected')
                ];

                slideItems.forEach((elem, index) => {
                    if(elem){
                        if(elem.querySelector('.items').offsetWidth<=0) status = false;
                        if(elem.querySelector('.items').offsetWidth<=elem.offsetWidth){
                            slideButtons[index].classList.add('hidden');
                        }else{
                            slideButtons[index].classList.remove('hidden');
                        }
                        
                        this.slideOnScroll(elem);
                    }
                });

                return status;
            },
            filter(key, type, value){

                // put selected categoru and tags in variable
                // this also can be used to managed selected item class
                if (this.selectedFilter[type].includes(value)) {
                    this.selectedFilter[type].splice(this.selectedFilter[type].indexOf(value),1);
                } else {
                    this.selectedFilter[type].push(value);
                }

                if(key==='reset-this-filter'){
                    this.selectedFilter[type] = [];
                }

                // set next and prev button visibility
                if (type === 'tag') {
                    this.detectButtonVisibility();
                }
                
                let filteredList = this.filterbyTagsAndCategories(this.items, this.selectedFilter);
                this.filteredItems = filteredList;                
                
            },
            downloadTrigger () {
                this.isMoodboardDownloadInfo = true;

                axios({
                    url: this.data.downloadLink,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    if (!window.navigator.msSaveOrOpenBlob){
                        // BLOB NAVIGATOR
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', (this.projectName ?? 'colorsteel-moodboard') + '.pdf');
                        document.body.appendChild(link);
                        link.click();

                        const message = {
                            title: 'Item downloaded',
                            text: 'Item downloaded',
                        }
                        
                        notify(message);
                        this.appendtoNotification(message);

                    }else{
                        // BLOB FOR EXPLORER 11
                        const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]),this.projectName +".pdf");
                    }
                });
            },
            addToMoodBoardTrigger () {
                
                alert('addToMoodBoard Triggered'); // Dev testing trigger alert
            },
            closeModalDownloaInfo(){
                this.isMoodboardDownloadInfo = false;
            },
            closeInfo() {
                this.isInfoVisible = false;
                sessionStorage.setItem('infonotvisible', true);
            },
            showModal() {
                this.isModalVisible = true;

                const body = document.body;
                body.classList.add("fs-modal-visible");

                this.intervalID = setInterval(() => {
                    let status = this.detectButtonVisibility();

                    const galleryModal = document.querySelector('.inspiration-gallery-modal .modal-backdrop');
                    galleryModal?.addEventListener('scroll', this.onScrollHandler);

                    if(status) clearInterval(this.intervalID );
                }, 100);

            },
            closeModal() {
                this.isModalVisible = false;

                const galleryModal = document.querySelector('.inspiration-gallery-modal .modal-backdrop');
                galleryModal.removeEventListener('scroll', this.onScrollHandler);
            },
            reloadPage() {
                window.location.reload();

            },

            copyShare() {
                let shareLink = document.querySelector('#shareLink')
                shareLink.setAttribute('type', 'text')    // 不是 hidden 才能複製
                shareLink.select()

                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';

                    const message = {
                        title: 'Share URL copy was ' + msg,
                        text: 'Share URL copy was ' + msg,
                    }
                    
                    notify(message);
                    this.appendtoNotification(message);
                } catch (err) {
                }
            },
            showShare() {
                this.isShareVisible = true;
            },
            closeShare() {
                this.isShareVisible = false;

            },
            projectNameChange () {
                var id = document.querySelector("input[name=project]").value;
                axios.get('/moodboardapi/name/' + id + '/update/')
                    .then(response => {
                        
                        sessionStorage.setItem('projectname', 'project name updated')

                        const message = {
                            title: 'Project name updated',
                            text: 'Project name updated',
                        }
                        
                        // do debounce to prevent flood of notification
                        // this.$notify(message);
                        // this.appendtoNotification(message);
                        this.renameHandlerEvent(message);
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },

            renameHandlerEvent() {},
            renameHandler (message) {
                notify(message);
                this.appendtoNotification(message);
            },
            toggleExpandFilter() {
                this.isFilterExpanded = !this.isFilterExpanded;
            },
            onScrollHandler(event) {
                if (!this.scrollTicking) {
                    window.requestAnimationFrame(() => {
                        const windowPosY = event.target.scrollTop;
                        const filterPosY = this.$refs.itemFilterRef.offsetTop;
                        const filterHolderPosY = this.$refs.itemFilterHolderRef.offsetTop;

                        // set sticky
                        if (windowPosY > ((filterHolderPosY || filterPosY) + (this.$refs.itemFilterHolderRef.offsetHeight || this.$refs.itemFilterRef.offsetHeight))) {
                            this.isFilterSticky = true;
                        } else {
                            this.isFilterSticky = false;
                            this.$refs.itemFilterHolderRef.style.height = `${this.$refs.itemFilterRef.offsetHeight}px`
                        }

                        // set autocollapse
                        if (this.isFilterSticky && this.prevWindowPosY < windowPosY) {
                            this.isFilterExpanded = false;
                        }
                        this.prevWindowPosY = windowPosY;

                        this.scrollTicking = false;
                    });

                    this.scrollTicking = true;
                }
            },
            setMasonryWallGap() {
                const browserWidth = window.innerWidth;

                // desktop
                if (browserWidth >= 768) {
                    this.masonryWallGap = 30;
                } else {
                    this.masonryWallGap = 17;
                }
            },
            toggleFav(favItem) {
                // update masonry grid when moodboard item removed from favorite
                if (favItem.action === 'removed') {
                    this.moodboardItems = this.moodboardItems.filter(moodboardItem => {
                        return favItem.id !== moodboardItem.id
                    })
                }

                // update favorite icon on modal when moodboard item removed from favorite
                this.filteredItems = this.filteredItems.map(filteredItem => {
                    const _filteredItem = filteredItem

                    if (favItem.action === 'removed' && favItem.id === _filteredItem.id) {
                        _filteredItem.isFavorite = ''
                    }

                    return _filteredItem
                })
            },
            toggleFavModal(favItem) {
                // update masonry grid when modal moodboard item removed from favorite
                if (favItem.action === 'removed') {
                    this.moodboardItems = this.moodboardItems.filter(moodboardItem => {
                        return favItem.id !== moodboardItem.id
                    })
                }
            }
        },
        created() {
            const app = this;
            
            app.renameHandlerEvent = debounce(function(message){
                app.renameHandler(message);
            }, 1000);

            if (sessionStorage.getItem('infonotvisible')){
                this.isInfoVisible = false;
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../scss/abstracts/variables";

    .banner--moodboard {
        hr {
            margin: 15px 0;

            @media #{$lg} {
                margin: 30px 0 20px;
            }
        }
    }

    .moodboard-form-wrapper {
        display: flex;
        justify-content: space-between;

        form {
            flex: 1;

            @media #{$lg} {
                margin-right: 100px;
            }
        }
        
        .form-group {
            margin-bottom: 0;
        }
    }

    .wrapper-project-name{
        display: flex;
        flex-wrap: wrap;

        @media #{$lg} {
            flex-wrap: nowrap;
            text-align: right;
            justify-content: right;
        }

        input{
            margin-right: 0px;
            margin-bottom: 0;
            padding: 14px 15px;
        }

        .save-button{
            display: flex;
            align-items: center;
            justify-content: center;
            height: 36px;
            padding: 0;
            margin-top: 15px;
            margin-left: auto;
            min-width: 108px;

            @media #{$lg} {
                height: 49px;
                margin-top: 0;
                min-width: 150px;
            }
        }
    }

    .moodboard-cta-wrapper {
        display: flex;
        align-items: flex-end;
    }

    .moodboard-cta {
        background: rgba(255, 254, 250, 0.80);
        border-radius: 6px;
        display: flex;
        gap: 18px;
        padding: 8px 10px;
        position: fixed;
        bottom: 35px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;

        @media #{$lg} {
            background-color: transparent;
            border-radius: 0;
            margin-bottom: 6px;
            padding: 0;
            position: relative;
            bottom: unset;
            left: unset;
            transform: none;
        }
    }

    .add-to-moodboard-wrapper{
        margin-bottom: 10px;
    }

    .share-button{
        margin-top: 0;
        margin-bottom: 0;
        margin-right: 0;
    }

    .download-button{
        margin-top: 0;
        margin-bottom: 0;
        margin-right: 0;
        min-width: 180px;
    }

    .items--featured {
        overflow-x: scroll;
        margin: 2rem 0;

        @media #{$md} {
            margin: 8rem 0;
            overflow-x: inherit;
        }

        .container-mobile-width {
            min-width: 62em;

            @media #{$md} {
                min-width: inherit;
            }
        }
    }

    .item-filter {
        background-color: #fffefa;
        z-index: 20;

        &.sticky {
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05);
            position: fixed;
            top: 0;
            left: 0;
            margin-top: -1px !important;
            padding-top: 20px;
            width: 100%;

            .filter-wrapper--separator {
                display: none;
            }

            .filter-wrapper--toggle {
                display: flex;
                justify-content: center;
                margin-top: 24px;
                margin-bottom: 20px;

                .toggle {
                    cursor: pointer;
                    display: flex;
                    gap: 7px;
                }

                p {
                    margin: 0;
                }

                span {
                    transition: transform 250ms ease-in-out;
                    transform: rotate(180deg);
                }
            }
        }

        &.sticky.collapsed {
            padding-top: 0;

            .filter-wrapper {
                display: none;
            }

            .filter-wrapper--toggle {
                margin-top: 16px;
                margin-bottom: 16px;

                span {
                    transform: rotate(0deg);
                }
            }
        }

        .container {
            padding-bottom: 0 !important;
        }

        .filter-wrapper--toggle {
            display: none;
        }
    }

    .filter-wrapper--text-icon-selected {
        position: relative;

        .separator {
            border-bottom: 1px solid #EEECE3;
            margin-top: 20px;
            margin-bottom: 20px;
            margin-left: 2rem;
            margin-right: 2rem;

            @media #{$sm} {
                margin-left: 0;
                margin-right: 0;
            }
        }

        .clear {
            cursor: pointer;
            height: 24px;
            margin-left: 7px;

            @media #{$md} {
                margin-left: 10px;
            }
        }
    }

    .card {
        &.card--Masonry,
        &.card--masonry,
        &.card--full {
            margin-bottom: 0;
            padding-bottom: 10px;

            @media #{$md} {
                margin-bottom: 3rem;
                padding-bottom: 2rem;
            }
        }
    }
</style>

<style lang="scss">
@import "../../scss/abstracts/variables";
@import "../../scss/abstracts/mixins";

body {
    .moodboard-content-template {
        margin-top: 120px;

        @media (min-width: 1200px) {
            margin-top: 160px;
        }
    }

    &.profile-links--visible {
        .moodboard-content-template {
            margin-top: 141px;

            @media #{$hd} {
                margin-top: 181px;
            }
        }
    }
}

.moodboard-content-template {
    .inspiration-gallery-modal,
    .moodboard--ideas {
        .card {
            .info--wrap {
                align-items: flex-start;
                flex-direction: row;

                .info {
                    margin-right: 1.5rem;
                    width: auto;

                    &:last-child {
                        margin-right: 0;
                    }

                    .info-item {
                        display: block;
                        height: auto;
                        width: auto;
                        width: auto;
                        margin-right: 9px;

                        @media #{$md} {
                            margin-right: 1.5rem;
                        }

                        &:last-child {
                            margin-right: 0;
                        }

                        .colour-card {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                        }

                        .solutionset-name,
                        .colour-card .info {
                            display: block;
                            font-size: 8px;
                            margin-bottom: 0;
                            margin-top: 0.5rem;
                            width: auto;
                            padding-left: 0;
                            padding-right: 0;
                            font-family: $font-primary-med;

                            @media #{$md} {
                                font-size: 12px;
                            }

                            span {
                                font-family: $font-primary-med;
                            }
                        }

                        &.info--colour {
                            .card {
                                margin-bottom: 0;
                            }
                        }
                    }
                }
            }

            .card-image {
                margin-bottom: 5px;
    
                @media #{$md} {
                    margin-bottom: 2rem;
                }
            }

            .pin-button__wrap {
                display: none;

                @media #{$md} {
                    display: block;
                }
            }

            h4 {
                margin: 0 0 6px 0;

                @media #{$md} {
                    margin: 0.425em 0 0.85em 0;
                }
            }

            .solutionset-icon {
                width: 28px;
                height: 28px;
                
                @media #{$md} {
                    width: 50px;
                    height: 50px;
                }
            }

            .colour-circle--small {
                width: 28px;
                height: 28px;

                @media #{$md} {
                    width: 50px;
                    height: 50px;
                }
            }
            .colour-card .title {
                margin: 0;
            }
        }
    }
}

.moodboard-modal-info {
    h5 {
        @include font-size(14);
        margin-top: 0;
        margin-bottom: 10px;
    }

    p {
        @include font-size(12);
        @include line-height(22, 'rem');
        
        &:first-child {
            margin-top: 0;
        }
        &:last-child {
            margin-bottom: 0;
        }
    }


    .image-item{

        margin-top:20px;
        max-height: 140px;
        width: auto;

        @media #{$sm} {
            margin-top:0;
            max-width: 100%;
            max-height: 100%;
        }

    }

}


    
.moodboard-download-info {
    .wysiwyg-content {
        :first-child {
            margin-top: 0;
        }

        :last-child {
            margin-bottom: 0;
        }
    }
}
</style>